export const MOCK_USER_A_ID = 'MOCK_USER_A_ID'
export const MOCK_USER_B_ID = 'MOCK_USER_B_ID'
